// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-distribution-modal {
    max-width: 600px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    border: none;
    padding: 0;
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.1);
}

.manage-distribution-modal-body {
    font-size: 14px;
    color: #000;
    padding: 13px 24px;
    display: flex;
    flex-direction: column;
    row-gap: 24px;
}

.manage-distribution-modal-footer {
    align-self: flex-end;
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;
    width: 100%;
}

.manage-distribution-modal-button {
    background-color: rgb(255, 255, 255);
    border: 1px solid #bdbdbd;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px 32px;
    color: #000;
    transition: background-color 100ms ease;
}

.manage-distribution-modal-link-button {
    all: unset;
    color: #00948e;
    font-size: 14px;
    cursor: pointer;
    text-decoration: underline;
}

.manage-distribution-modal-divider {
    height: 1px;
    width: 100%;
    background: #e1e1e1;
}

.manage-distribution-modal-title-wrapper {
    font-size: 24px;
    display: flex;
    align-items: center;
    padding: 19px 26px 13px 26px;
    justify-content: space-between;
}

.manage-distribution-modal-title {
    display: flex;
    column-gap: 16px;
    margin: 0;
    padding: 0;
    align-items: center;
}

.manage-distribution-modal-cross-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0;
    border: none;
    outline: none;
    background-color: transparent;
}

.manage-distribution-modal-button {
    border-radius: 24px;
    color: #fff;
    background-color: #00a9a4;
    padding: 8px 32px;
    font-size: 14px;
}

.manage-distribution-modal-button:hover {
    background-color: #00948e;
}

.manage-distribution-modal-input-label {
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
}
`, "",{"version":3,"sources":["webpack://./client/components/product-collection/footer/components/left-side/manage-distribution-modal/manage-distribution-modal.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,cAAc;IACd,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".manage-distribution-modal {\n    max-width: 600px;\n    border-radius: 4px;\n    display: flex;\n    flex-direction: column;\n    border: none;\n    padding: 0;\n    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.1);\n}\n\n.manage-distribution-modal-body {\n    font-size: 14px;\n    color: #000;\n    padding: 13px 24px;\n    display: flex;\n    flex-direction: column;\n    row-gap: 24px;\n}\n\n.manage-distribution-modal-footer {\n    align-self: flex-end;\n    display: flex;\n    justify-content: space-between;\n    padding: 16px 24px;\n    width: 100%;\n}\n\n.manage-distribution-modal-button {\n    background-color: rgb(255, 255, 255);\n    border: 1px solid #bdbdbd;\n    border-radius: 24px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 8px 32px;\n    color: #000;\n    transition: background-color 100ms ease;\n}\n\n.manage-distribution-modal-link-button {\n    all: unset;\n    color: #00948e;\n    font-size: 14px;\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n.manage-distribution-modal-divider {\n    height: 1px;\n    width: 100%;\n    background: #e1e1e1;\n}\n\n.manage-distribution-modal-title-wrapper {\n    font-size: 24px;\n    display: flex;\n    align-items: center;\n    padding: 19px 26px 13px 26px;\n    justify-content: space-between;\n}\n\n.manage-distribution-modal-title {\n    display: flex;\n    column-gap: 16px;\n    margin: 0;\n    padding: 0;\n    align-items: center;\n}\n\n.manage-distribution-modal-cross-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    margin: 0;\n    border: none;\n    outline: none;\n    background-color: transparent;\n}\n\n.manage-distribution-modal-button {\n    border-radius: 24px;\n    color: #fff;\n    background-color: #00a9a4;\n    padding: 8px 32px;\n    font-size: 14px;\n}\n\n.manage-distribution-modal-button:hover {\n    background-color: #00948e;\n}\n\n.manage-distribution-modal-input-label {\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
